import {ExtendedControlsPrefix} from "../vos/extendedcontrolsprefix.js";
import {ExtendedControlIcons} from "../vos/extendedcontrolicons.js";

export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager,
        SPACING_PROPERTIES = [
            'margin',
            'margin-left',
            'margin-right',
            'margin-top',
            'margin-bottom',
            'padding',
            'padding-left',
            'padding-right',
            'padding-top',
            'padding-bottom'
        ],
        BORDER_RADIUS = 'border-radius',
        PROP_LOCK = {},
        PREV_VALUES = {};

    const SLIDER_MORE_OPTIONS_ICON_1 = 1;
    const SLIDER_MORE_OPTIONS_ICON_2 = 2;
    const SLIDER_MORE_OPTIONS_ICON_3 = 3;
    const SLIDER_MORE_OPTIONS_ICON_4 = 4;


    styleManager.addType(window.PMW.emails.styles.ID_SLIDER, {
        create({props, change}) {
            const el = document.createElement('div');
            props.component = props.component || editor.getSelected();

            if (typeof props.step === 'undefined') {
                props.step = 1;
            }

            if (typeof props.min === 'undefined') {
                props.min = 0;
            }

            if (typeof props.inputType === 'undefined') {
                props.inputType = 'text';
            }

            if (typeof props.max === 'undefined') {
                props.max = 100;
            }

            if (typeof props.units === 'undefined') {
                props.units = '';
            }

            if (typeof props.extendedControls === 'undefined') {
                props.extendedControls = false;
            }

            if (props.property === 'border-radius') {
                const el = props.component.getEl()?.getBoundingClientRect() || {width: 0, height: 0},
                    max = Math.min(el.width, el.height) / 2;
                props.max = max || props.max;
            }

            el.innerHTML = getSliderHTML(props);
            const desktopEl = el.querySelector('.js-container-desktop'),
                tabletEl = el.querySelector('.js-container-tablet'),
                mobileEl = el.querySelector('.js-container-mobile');

            function attachHandlers(el) {
                const inputEl = el.querySelector('.pmw-slider');
                sliderControlsHandlers.call(this, inputEl, props, change, el);
                if (props.extendedControls) {
                    sliderExtendedControlsHandlers.call(this, el, props, change);
                }
                setSliderInitialValue(el, props);
            }

            let defaultPropName = props.property;
            attachHandlers(desktopEl);

            if (props.isResponsive) {
                const propertyName = props.property;
                props.property = window.PMW.emails.MOBILE_CSS_PROP_PREFIX + propertyName;
                attachHandlers(mobileEl);

                props.property = window.PMW.emails.TABLET_CSS_PROP_PREFIX + propertyName;
                attachHandlers(tabletEl);
            }

            props.property = defaultPropName;

            return el;
        },
        emit({props}, {el, event, complete, propertyName, isSingleProperty}) {
            let property = props.property;

            if (typeof propertyName === 'string') {
                property = propertyName;
            }

            if (typeof property === 'undefined') {
                return;
            }

            const {value} = event.target,
                tabletCssPropRegex = new RegExp(`^${window.PMW.emails.TABLET_CSS_PROP_PREFIX}`),
                mobileCssPropRegex = new RegExp(`^${window.PMW.emails.MOBILE_CSS_PROP_PREFIX}`),
                isTabletPropUpdate = props.isResponsive && tabletCssPropRegex.test(property),
                isMobilePropUpdate = props.isResponsive && mobileCssPropRegex.test(property);

            handleCustomProperty(property, value);
            if (isTabletPropUpdate) {
                editor.runCommand(window.PMW.emails.commands.SET_DEVICE_MEDIA_QUERY, {
                    property,
                    value: value + props.units,
                    id: props.component.ccid,
                    deviceID: window.PMW.emails.DEVICE_TABLET,
                    cssPrefix: window.PMW.emails.TABLET_CSS_PROP_PREFIX,
                });

            } else if (isMobilePropUpdate) {
                editor.runCommand(window.PMW.emails.commands.SET_DEVICE_MEDIA_QUERY, {
                    property,
                    value: value + props.units,
                    id: props.component.ccid,
                    deviceID: window.PMW.emails.DEVICE_MOBILE,
                    cssPrefix: window.PMW.emails.MOBILE_CSS_PROP_PREFIX,
                });
            }

            toggleVisibility(props.toggleProp, value);

            let units = 'px';
            if (typeof props.units !== 'undefined') {
                units = props.units;
            }

            const valueRes = value + units;
            editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {property, value: valueRes, component: props.component});

            if (property === 'width' && props.component.get('tagName').toLowerCase() === 'img') {
                editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {
                    property: 'height',
                    value: 'auto',
                    component: props.component
                });
            }

            toggleSliderControlsDisabledStateIfExists(el, props.max, props.min, value);
            gaTrackingForHeight(property, props.component, valueRes);

            if (props.extendedControls && !isSingleProperty) {
                let extendedControlsHelper = getExtendedControlsPrefixes(property),
                    topProperty = extendedControlsHelper.getPrefixedTopProperty(),
                    bottomProperty = extendedControlsHelper.getPrefixedBottomProperty(),
                    leftProperty = extendedControlsHelper.getPrefixedLeftProperty(),
                    rightProperty = extendedControlsHelper.getPrefixedRightProperty();

                gaTrackingForSpacing(property, props.component);

                if (property !== 'margin') {
                    editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {property: leftProperty, value: valueRes, component: props.component});
                    editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {property: rightProperty, value: valueRes, component: props.component});
                }

                editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {property: topProperty, value: valueRes, component: props.component});
                editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {property: bottomProperty, value: valueRes, component: props.component});
                editor.trigger('component:styleUpdate:' + property, props.component);
            } else {
                if (props.extendedControls && isSingleProperty) {
                    updateSliderInputTextIfNeeded(el);
                }
                gaTrackingForCustomSpacing(property, props.component);
            }
        },
        update({value, el, props}) {
        }
    });

    function getExtendedControlsPrefixes(property) {
        let topPrefix = '-top',
            bottomPrefix = '-bottom',
            leftPrefix = '-left',
            rightPrefix = '-right';

        if (isBorderRadiusProperty(property)) {
            topPrefix = '-top-right-radius';
            bottomPrefix = '-bottom-right-radius';
            leftPrefix = '-bottom-left-radius';
            rightPrefix = '-top-left-radius';
        }

        return (new ExtendedControlsPrefix(property, topPrefix, rightPrefix, bottomPrefix, leftPrefix));
    }

    function toggleSliderControlsDisabledStateIfExists(sliderEl, maxValue, minValue, currentValue) {
        const sliderControlMinus = sliderEl.querySelector('.pmw-slider-minus');
        const sliderControlPlus = sliderEl.querySelector('.pmw-slider-plus');

        if (!sliderControlMinus || !sliderControlPlus) {
            return;
        }

        if (Number(currentValue) === Number(maxValue)) {
            sliderControlPlus.classList.add('disabled');
            sliderControlMinus.classList.remove('disabled');
        } else if (Number(currentValue) === Number(minValue)) {
            sliderControlMinus.classList.add('disabled');
            sliderControlPlus.classList.remove('disabled');
        } else {
            sliderControlPlus.classList.remove('disabled');
            sliderControlMinus.classList.remove('disabled');
        }
    }

    function gaTrackingForHeight(property, component, eventValue) {
        if (property === 'height') {
            if (isPropLockUnavailable(property)) {
                return;
            } else {
                setPropLock(property);
            }

            // Tracking temporarily disabled on 8th Nov 2023
            // editor.runCommand(window.PMW.emails.commands.TRACK_GA_EVENT_COMPONENT, {
            //     component: component,
            //     eventAction: 'EmailMaker_UpdateHeight',
            //     eventValue: eventValue
            // });

            freePropLockInInterval(property);
        }
    }

    function gaTrackingForSpacing(property, component) {
        if (SPACING_PROPERTIES.includes(property)) {
            if (isPropLockUnavailable(property)) {
                return;
            } else {
                setPropLock(property);
            }

            // Tracking temporarily disabled on 8th Nov 2023
            // editor.runCommand(window.PMW.emails.commands.TRACK_GA_EVENT_COMPONENT, {
            //     component: component,
            //     eventAction: 'EmailMaker_UpdateSpacing'
            // });

            freePropLockInInterval(property);
        }
    }

    function updateSliderInputTextIfNeeded(el) {
        const topValue = el.querySelector('.extended-property-input-top')?.value;
        const bottomValue = el.querySelector('.extended-property-input-bottom')?.value;
        const leftValue = el.querySelector('.extended-property-input-left')?.value;
        const rightValue = el.querySelector('.extended-property-input-right')?.value;

        const values = [topValue, bottomValue, leftValue, rightValue];
        const inputElement = el.querySelector('.pmw-slider-text');
        const InputUnits = el.querySelector('.pmw-email-editor-slider-units')

        const isMixedInput = new Set(values).size !== 1;

        if (isMixedInput) {
            inputElement.type = 'text';
            inputElement.value = i18next.t('pmwjs_mixed');
            inputElement.classList.add('-mixed');
            InputUnits.classList.add('_hidden');
        } else {
            inputElement.type = 'number';
            inputElement.value = topValue;
            inputElement.classList.remove('-mixed');
            InputUnits.classList.remove('_hidden');
        }
    }

    function gaTrackingForCustomSpacing(property, component) {
        if (SPACING_PROPERTIES.includes(property)) {
            if (isPropLockUnavailable(property)) {
                return;
            } else {
                setPropLock(property);
            }

            // Tracking temporarily disabled on 8th Nov 2023
            // editor.runCommand(window.PMW.emails.commands.TRACK_GA_EVENT_COMPONENT, {
            //     component: component,
            //     eventAction: 'EmailMaker_CustomSpacing',
            //     eventValue: property
            // });

            freePropLockInInterval(property);
        }
    }

    /**
     * Using a lock to make sure we don't bombard analytics with slider events
     * @param {string} property
     * @returns {boolean}
     */
    function isPropLockUnavailable(property) {
        if (PROP_LOCK[property] === 'undefined') {
            PROP_LOCK[property] = false;
            return false;
        }

        return PROP_LOCK[property] === true;
    }

    /**
     * @param {string} property
     */
    function setPropLock(property) {
        PROP_LOCK[property] = true;
    }

    /**
     * @param {string} property
     * @param {int} interval
     */
    function freePropLockInInterval(property, interval = 2000) {
        setTimeout(() => PROP_LOCK[property] = false, interval);
    }

    function sliderExtendedControlsHandlers(el, props, change) {
        PMW.onClick($(el).find('.pmw-slider-more-options'), null, function () {
            let t = $(this),
                extendedControlsParent = t.parents('.pmw-email-editor-slider-container').find('.extended-properties-container'),
                currentComponent = props.component;
            extendedControlsParent.toggleClass('_hidden');

            if (extendedControlsParent.hasClass('_hidden')) {
                currentComponent.addAttributes({'data-has-extended-controls': 0});
                t.removeClass('-selected');
            } else {
                currentComponent.addAttributes({'data-has-extended-controls': 1});
                t.addClass('-selected');
            }
        });

        const extendedPropertyInputs = el.querySelectorAll('.extended-property-input')
        const extendedPropertyInputContainers = el.querySelectorAll('.extended-property-container');

        extendedPropertyInputs.forEach(input => {
            const extendedPropertyContainer = input.closest('.extended-property-container');
            const containerId = extendedPropertyContainer.getAttribute('data-id');
            const moreOptionsFirstIcon = el.querySelector('.more-options-icon');
            const moreOptionsSelectedIcon = el.querySelector(`.more-options-icon[data-id="${containerId}"]`);

            input.addEventListener('focus', function() {
                extendedPropertyInputContainers.forEach(container => {
                    container.classList.remove('-selected');
                });

                extendedPropertyContainer.classList.add('-selected');
                moreOptionsFirstIcon.classList.add('-mixed')
                moreOptionsSelectedIcon.classList.remove('_hidden');
            });

            input.addEventListener('blur', function() {
                extendedPropertyContainer.classList.remove('-selected');
                moreOptionsSelectedIcon.classList.add('_hidden');
                moreOptionsFirstIcon.classList.remove('-mixed')
            });
        });

        let extendedControlsHelper = getExtendedControlsPrefixes(props.property);

        if (props.property !== 'margin') {
            el.querySelector('.extended-property-input-right').addEventListener('change', function (el, props, event) {
                let propertyName = extendedControlsHelper.getPrefixedRightProperty(),
                    isSingleProperty = true;
                change({el, event, propertyName, isSingleProperty});
            }.bind(this, el, props));

            el.querySelector('.extended-property-input-left').addEventListener('change', function (el, props, event) {
                let propertyName = extendedControlsHelper.getPrefixedLeftProperty(),
                    isSingleProperty = true;

                change({el, event, propertyName, isSingleProperty});
            }.bind(this, el, props));
        }

        el.querySelector('.extended-property-input-top').addEventListener('change', function (el, props, event) {
            let propertyName = extendedControlsHelper.getPrefixedTopProperty(),
                isSingleProperty = true;
            change({el, event, propertyName, isSingleProperty});
        }.bind(this, el, props));

        el.querySelector('.extended-property-input-bottom').addEventListener('change', function (el, props, event) {
            let propertyName = extendedControlsHelper.getPrefixedBottomProperty(),
                isSingleProperty = true;
            change({el, event, propertyName, isSingleProperty});
        }.bind(this, el, props));
    }

    function sliderControlsHandlers(inputEl, props, change, el) {
        const propertyName = props.property;

        inputEl.addEventListener('change', function (el, event) {
            const newValue = el.querySelector('.pmw-slider').value;

            // setting a temporary value so the actual value change can trigger save & undo
            editor.getModel().skip(_ => onSliderInput(el, event, props, change, PREV_VALUES[propertyName]));

            onSliderInput(el, event, props, change, newValue);
            PREV_VALUES[propertyName] = newValue;
        }.bind(this, el));

        inputEl.addEventListener('input', function (el, event) {
            editor.getModel().skip(_ => {
                onSliderInput(el, event, props, change);
            });
        }.bind(this, el));

        inputEl.addEventListener('mouseup', function (el, event) {
            editor.getModel().skip(_ => {
                onSliderInput(el, event, props, change);
            });
        }.bind(this, el));

        const sliderText = el.querySelector('.pmw-slider-text');
        const sliderTextContainer = sliderText.closest('.pmw-slider-input-container');
        const sliderControlsContainer = sliderText.closest('.pmw-slider-step-controls-container');

        sliderTextContainer.addEventListener('click', function () {
            sliderControlsContainer.classList.add('-selected');
            sliderText.focus();
        });

        sliderText.addEventListener('focus', function () {
            sliderControlsContainer.classList.add('-selected');

            if (sliderText.type === 'text') {
                sliderText.type = 'number';
                sliderText.value = '';
                sliderText.classList.remove('-mixed');
            }

            const unitContainer = sliderTextContainer.querySelector('.pmw-email-editor-slider-units');
            if (unitContainer) {
                unitContainer.classList.remove('_hidden');
            }
        });

        sliderText.addEventListener('blur', function () {
            sliderControlsContainer.classList.remove('-selected');
        });

        sliderText.addEventListener('change', function (el, event) {
            let isSingleProperty = false,
                slider = el.querySelector('.pmw-slider'),
                textbox = el.querySelector('.pmw-slider-text'),
                val = getValidatedPropertyValue(textbox);

            slider.value = val;
            if (props.extendedControls) {
                updateExtendedControlInputs(el, val);
            }

            editor.runCommand(window.PMW.emails.commands.UPDATE_SLIDER_VALUE, {inputElements: [slider, textbox], property: propertyName, value: slider.value});
            change({el, event, propertyName, isSingleProperty});
        }.bind(this, el));

        const sliderPlus = el.querySelector('.pmw-slider-plus');
        const sliderMinus = el.querySelector('.pmw-slider-minus');
        sliderPlus.addEventListener('click', function () {
            const input = el.querySelector('.pmw-slider');
            input.value = parseFloat(input.value) + (props.step || 1);
            triggerSliderChange(input);
        });

        sliderMinus.addEventListener('click', function () {
            const input = el.querySelector('.pmw-slider');
            input.value = parseFloat(input.value) - (props.step || 1);
            triggerSliderChange(input);
        });


    }

    /**
     * @param {HTMLElement} el
     * @param {Event} event
     * @param {object} props
     * @param {function} change
     * @param {number} [value] optional value to set instead of using slider's current value
     */
    function onSliderInput(el, event, props, change, value = undefined) {
        let isSingleProperty = false,
            propertyName = props.property,
            slider = el.querySelector('.pmw-slider'),
            textbox = el.querySelector('.pmw-slider-text');

        value = typeof value !== "undefined" ? value : slider.value;
        slider.value = value;
        textbox.value = value;

        if (props.extendedControls) {
            updateExtendedControlInputs(el, value);
        }

        if (props.isResponsive) {
            let selectedDevice = editor.Devices.getSelected();
            if (selectedDevice && selectedDevice.id === window.PMW.emails.DEVICE_MOBILE) {
                propertyName = window.PMW.emails.MOBILE_CSS_PROP_PREFIX + props.property;
            }

            if (selectedDevice && selectedDevice.id === window.PMW.emails.DEVICE_TABLET) {
                propertyName = window.PMW.emails.TABLET_CSS_PROP_PREFIX + props.property;
            }
        }

        editor.runCommand(window.PMW.emails.commands.UPDATE_SLIDER_VALUE, {inputElements: [slider, textbox], property: propertyName, value: value});
        change({el, event, propertyName, isSingleProperty});
    }

    function updateExtendedControlInputs(el, value) {
        el.querySelector('.extended-property-input-top').value = value;
        el.querySelector('.extended-property-input-bottom').value = value;
        el.querySelector('.extended-property-input-left').value = value;
        el.querySelector('.extended-property-input-right').value = value;
    }

    function getValidatedPropertyValue(el) {
        let t = $(el),
            v = parseInt(t.val()),
            min = parseInt(t.attr('min')),
            max = parseInt(t.attr('max'));

        if (v < min) {
            t.val(min);
            return min;
        } else if (v > max) {
            t.val(max);
            return max;
        }

        return v;
    }

    function isBorderRadiusProperty(style) {
        return style === BORDER_RADIUS;
    }

    function getAllStyledProperties(props) {
        let styles = props.component.getStyle(),
            topStyle = 0,
            bottomStyle = 0,
            leftStyle = 0,
            rightStyle = 0,
            extendedControlsHelper = getExtendedControlsPrefixes(props.property);

        if (styles) {
            if (typeof styles[extendedControlsHelper.getPrefixedTopProperty()] !== 'undefined') {
                topStyle = parseInt(styles[extendedControlsHelper.getPrefixedTopProperty()]);
            } else if (typeof styles[props.property] !== 'undefined') {
                topStyle = parseInt(styles[props.property]);
            }

            if (typeof styles[extendedControlsHelper.getPrefixedBottomProperty()] !== 'undefined') {
                bottomStyle = parseInt(styles[extendedControlsHelper.getPrefixedBottomProperty()]);
            } else if (typeof styles[props.property] !== 'undefined') {
                bottomStyle = parseInt(styles[props.property]);
            }

            if (typeof styles[extendedControlsHelper.getPrefixedRightProperty()] !== 'undefined') {
                rightStyle = parseInt(styles[extendedControlsHelper.getPrefixedRightProperty()]);
            } else if (typeof styles[props.property] !== 'undefined') {
                rightStyle = parseInt(styles[props.property]);
            }

            if (typeof styles[extendedControlsHelper.getPrefixedLeftProperty()] !== 'undefined') {
                leftStyle = parseInt(styles[extendedControlsHelper.getPrefixedLeftProperty()]);
            } else if (typeof styles[props.property] !== 'undefined') {
                leftStyle = parseInt(styles[props.property]);
            }
        }
        return {topStyle, bottomStyle, rightStyle, leftStyle};
    }

    function setExtendedControlsValues(el, props) {
        let styleObj = getAllStyledProperties(props);

        el.querySelector('.extended-property-input-top').value = styleObj.topStyle;
        el.querySelector('.extended-property-input-bottom').value = styleObj.bottomStyle;
        el.querySelector('.extended-property-input-right').value = styleObj.rightStyle;
        el.querySelector('.extended-property-input-left').value = styleObj.leftStyle;
    }

    function getIconsForSliderMoreOptions(property, type) {
        if (property === 'padding') {
            switch (type) {
                case SLIDER_MORE_OPTIONS_ICON_1:
                    return 'icon-spacing-active-top';
                case SLIDER_MORE_OPTIONS_ICON_2:
                    return 'icon-spacing-active-bottom';
                case SLIDER_MORE_OPTIONS_ICON_3:
                    return 'icon-spacing-active-left';
                case SLIDER_MORE_OPTIONS_ICON_4:
                    return 'icon-spacing-active-right';
                default:
                    return 'icon-edge-spacing'
            }
        }

        if (property === 'border-radius') {
            switch (type) {
                case SLIDER_MORE_OPTIONS_ICON_1:
                    return 'icon-corner-active-right';
                case SLIDER_MORE_OPTIONS_ICON_2:
                    return 'icon-corner-active-bottom-right';
                case SLIDER_MORE_OPTIONS_ICON_3:
                    return 'icon-corner-active-bottom-left';
                case SLIDER_MORE_OPTIONS_ICON_4:
                    return 'icon-corner-active-left';
                default:
                    return 'icon-corner'
            }
        }

        return '';
    }

    function getHideSliderInput(property) {
        if (property === 'padding') {
            return true;
        }

        if (property === 'border-radius') {
            return true;
        }

        return false;
    }

    function getSliderHTML(props) {
        const component = props.component;
        let desktopContainer = '',
            tabletContainer = '',
            mobileContainer = '',
            propertyInputSelectors = '',
            desktopContainerClassName = 'js-container-desktop',
            tabletContainerClassName = 'hidden-device-desktop hidden-device-mobile js-container-tablet',
            mobileContainerClassName = 'hidden-device-desktop hidden-device-tablet js-container-mobile',
            hideSliderInput = getHideSliderInput(props.property);

        desktopContainerClassName = (props.isResponsive ? 'hidden-device-tablet hidden-device-mobile ' : '') + desktopContainerClassName;

        let extendedControlsAlreadyVisible = false;
        if (props.extendedControls && getIsExtendedControlsPanelOpen(component)) {
            extendedControlsAlreadyVisible = true;
        }

        function getSliderContainerMarkup(props, responsiveTag = '', className = '') {
            return `<div class="pmw-email-editor-slider-container ${className}">
                <div class="pmw-email-editor-slider-label-container">
                    <span class="style-manager-label"> 
                        ${(responsiveTag ? `<span class="highlight-tag body-xxs-bold -rounded">${responsiveTag}</span>` : '') + props.propertyLabel}
                    </span>
                    <div class="pmw-email-editor-slider-input-options ${props.extendedControls ? '-extended' : ''}">
                        <div class="pmw-slider-step-controls-container flexbox ${hideSliderInput ? '' : '-step-enabled'}">
                            <i class="pmw-slider-minus pmw-icon size-icon-16 icon-minus -secondary -square ${hideSliderInput ? '_hidden' : ''}"></i>
                            <div class="pmw-slider-input-container">
                                <input aria-label="${i18next.t('pmwjs_property_slider', {property: props.property})}" data-units="${props.units}" class="pmw-slider-text js-emails-${props.property}-input ${!props.units ? '-center-align' : ''}" type="number" min="${props.min}" max="${props.max}" step="${props.step}"/>
                                <span class="pmw-email-editor-slider-units">${props.units}</span>
                            </div>
                        <i class="pmw-slider-plus pmw-icon size-icon-16 icon-plus -secondary -square ${hideSliderInput ? '_hidden' : ''}"></i>
                        </div>

                        ${(props.extendedControls ? `<div class="pmw-slider-more-options _position-relative ${extendedControlsAlreadyVisible ? '-selected' : ''}">
                                                        <i class="more-options-icon _position-absolute ${getIconsForSliderMoreOptions(props.property)}"></i>
                                                        <i data-id="${SLIDER_MORE_OPTIONS_ICON_1}" class="more-options-icon _position-absolute _hidden content-primary ${getIconsForSliderMoreOptions(props.property, SLIDER_MORE_OPTIONS_ICON_1)}"></i>
                                                        <i data-id="${SLIDER_MORE_OPTIONS_ICON_2}" class="more-options-icon _position-absolute _hidden content-primary ${getIconsForSliderMoreOptions(props.property, SLIDER_MORE_OPTIONS_ICON_2)}"></i>
                                                        <i data-id="${SLIDER_MORE_OPTIONS_ICON_3}" class="more-options-icon _position-absolute _hidden content-primary ${getIconsForSliderMoreOptions(props.property, SLIDER_MORE_OPTIONS_ICON_3)}"></i>
                                                        <i data-id="${SLIDER_MORE_OPTIONS_ICON_4}" class="more-options-icon _position-absolute _hidden content-primary ${getIconsForSliderMoreOptions(props.property, SLIDER_MORE_OPTIONS_ICON_4)}"></i>
                                                    </div>` : '')}
                    </div>
                </div>
                <input type="range" class="pmw-slider js-emails-${props.property}-input ${hideSliderInput ? '_hidden' : ''}" min="${props.min}" max="${props.max}" step="${props.step}" aria-label="${props.property}"/>
                ${propertyInputSelectors} 
            </div>`;
        }

        if (props.extendedControls) {
            let extendedControlIcons;

            if (typeof props.extendedControlIcons !== 'undefined' && props.extendedControlIcons instanceof ExtendedControlIcons) {
                extendedControlIcons = props.extendedControlIcons;
            } else {
                extendedControlIcons = new ExtendedControlIcons(
                    'icon-edge-spacing-top',
                    'icon-edge-spacing-bottom',
                    'icon-edge-spacing-left',
                    'icon-edge-spacing-right',
                );
            }

            let styleObj = getAllStyledProperties(props),
                topStyle = styleObj.topStyle,
                bottomStyle = styleObj.bottomStyle,
                rightStyle = styleObj.rightStyle,
                leftStyle = styleObj.leftStyle;

            propertyInputSelectors = '<div class="extended-properties-container suboption ' + (extendedControlsAlreadyVisible ? "" : "_hidden") + '">' +
                '<div class="extended-property-container" data-id="1">' +
                `<div class="extended-property-icon-container first"><i class="icon ${extendedControlIcons.first} extended-property-icon"></i></div>` +
                '<input type="number" aria-label="' + i18next.t("pmwjs_top") + '" class="extended-property-input extended-property-input-top" type="number" value="' + topStyle + `" step="${props.step}" min="${props.min}" max="${props.max}"` + '/>' +
                '</div>' +
                '<div class="extended-property-container" data-id="2">' +
                `<div class="extended-property-icon-container"><i class="icon ${extendedControlIcons.second} extended-property-icon"></i></div>` +
                '<input type="number" aria-label="' + i18next.t("pmwjs_bottom") + '" class="extended-property-input extended-property-input-bottom" type="number" value="' + bottomStyle + `" step="${props.step}" min="${props.min}" max="${props.max}"` + '/>' +
                '</div>' +
                '<div class="extended-property-container" data-id="3">' +
                `<div class="extended-property-icon-container"><i class="icon ${extendedControlIcons.third} extended-property-icon"></i></div>` +
                '<input type="number" aria-label="' + i18next.t("pmwjs_left") + '" class="extended-property-input extended-property-input-left" type="number" value="' + leftStyle + `" step="${props.step}" min="${props.min}" max="${props.max}"` + '/>' +
                '</div>' +
                '<div class="extended-property-container" data-id="4">' +
                `<div class="extended-property-icon-container"><i class="icon ${extendedControlIcons.fourth} extended-property-icon"></i></div>` +
                '<input type="number" aria-label="' + i18next.t("pmwjs_right") + '" class="extended-property-input extended-property-input-right" type="number" value="' + rightStyle + `" step="${props.step}" min="${props.min}" max="${props.max}"` + '/>' +
                '</div>' +
                '</div>';
        }
        desktopContainer = getSliderContainerMarkup(props, '', desktopContainerClassName);

        if (props.isResponsive) {
            const propertyName = props.property;
            props.property = window.PMW.emails.MOBILE_CSS_PROP_PREFIX + propertyName;
            mobileContainer = getSliderContainerMarkup(props, 'Mobile', mobileContainerClassName);
            props.property = window.PMW.emails.TABLET_CSS_PROP_PREFIX + propertyName;
            tabletContainer = getSliderContainerMarkup(props, 'Tablet', tabletContainerClassName);
            props.property = propertyName;
        }

        return `<div class="pmw-email-editor-slider-containers">
            ${desktopContainer}
            ${mobileContainer}
            ${tabletContainer}
        </div>`;
    }

    function setSliderInitialValue(el, props) {
        let value = opt.editor.runCommand(window.PMW.emails.commands.GET_COMPONENT_STYLE, {component: props.component, property: props.property}),
            slider = el.querySelector('.pmw-slider'),
            parsedValue = value !== null ? parseInt(value, 10) : parseInt(props.defaults, 10);

        parsedValue = isNaN(parsedValue) ? parseInt(props.defaults, 10) : parsedValue;
        slider.value = parsedValue;
        toggleSliderControlsDisabledStateIfExists(el, props.max, props.min, parsedValue);

        if (!isNaN(parsedValue)) {
            PREV_VALUES[props.property] = parsedValue;
            el.querySelector('.pmw-slider-text').value = parsedValue;
            editor.runCommand(window.PMW.emails.commands.UPDATE_SLIDER_VALUE, {inputElements: [slider], property: props.property, value: parsedValue});

            if (props.extendedControls) {
                setExtendedControlsValues(el, props);
            }
        }
    }

    function getIsExtendedControlsPanelOpen(component) {
        return typeof component.getAttributes()['data-has-extended-controls'] !== 'undefined' && parseInt(component.getAttributes()['data-has-extended-controls']) === 1
    }

    /**
     * @param {string} property
     * @param {number} currentValue
     */
    function toggleVisibility(property, currentValue) {
        if (!property) {
            return;
        }
        currentValue = parseInt(currentValue);

        if (currentValue) {
            $(`.gjs-sm-property__${property}`)?.removeClass('-collapsed');
        } else {
            $(`.gjs-sm-property__${property}`)?.addClass('-collapsed');
        }
    }

    function triggerSliderChange(input) {
        input.dispatchEvent(new Event('change'));
    }

    function handleCustomProperty(property, value) {
        if (property === 'pmw-cell-spacing') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_CELLS_SPACING, {sliderVal: value});
        }

        if (property === 'pmw-cell-border-width') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_CELLS_BORDER_WIDTH, {sliderVal: value});
        }

        if (property === 'pmw-cell-border-radius') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_CELLS_BORDER_RADIUS, {sliderVal: value});
        }

        if (property === 'pmw-icon-margin') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_SOCIAL_LINK_SPACING, {gap: value});
        }

        if (property === 'pmw-icon-size') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_SOCIAL_LINK_SIZE, {size: value});
        }

        if (property === 'padding') {
            editor.runCommand(window.PMW.emails.commands.HANDLE_TABLE_PADDING);
        }
    }
}
